module.exports = __webpack_public_path__ + "img/tema-1-14.e7e86417.png";